import { FC } from "react";
import { Product } from "@prisma/client";
import { useRouter } from "next/router";

import { MobileImageGallery } from "./image-gallery";

import LikeButton from "@components/common/like-button";
import { calculatePrice, formatPrice } from "@utils/price";

type Props = Pick<
  Product,
  | "id"
  | "name"
  | "description"
  | "price"
  | "discount"
  | "longDescription"
  | "nameEn"
  | "descriptionEn"
  | "longDescriptionEn"
  | "photos"
>;

const KeyDescriptions: FC<Props> = ({
  id,
  name,
  nameEn,
  price,
  photos,
  discount,
  description,
  descriptionEn,
  longDescription,
  longDescriptionEn,
}) => {
  const { locale } = useRouter();

  return (
    <div className="text-black flex flex-col items-baseline justify-between">
      <div className="flex flex-row justify-between w-full my-4 mb-6 px-4">
        <div className="w-full">
          <div className="flex flex-row justify-between items-center w-full">
            <h2 className="text-2xl font-bold">
              {locale === "en" ? nameEn : name}
            </h2>
            <div className="pr-4 flex justify-center items-center">
              <LikeButton className="w-8" {...{ productId: id }} />
            </div>
          </div>
          <span className="md:text-lg">
            {locale === "en" ? descriptionEn : description}
          </span>
        </div>
      </div>

      <div className="relative text-2xl font-bold mb-4 px-4">
        {discount !== 0 && (
          <div
            {...{
              className:
                discount !== 0
                  ? "line-through font-normal text-base absolute -top-3"
                  : undefined,
            }}
          >
            {formatPrice(price, true)}
          </div>
        )}
        <div {...{ className: discount !== 0 ? "text-red-600" : undefined }}>
          {formatPrice(calculatePrice(price, discount), true)}
        </div>
      </div>
      <div className="md:hidden w-full">
        <MobileImageGallery {...{ photos }} />
      </div>
      <div
        className="prose text-black px-4"
        dangerouslySetInnerHTML={{
          __html: locale === "en" ? longDescriptionEn : longDescription,
        }}
      />
    </div>
  );
};

export default KeyDescriptions;
